export default __webpack_public_path__ + "static/media/envira.de6749de.svg";